import { DeleteQuestionModal } from './DeleteQuestionModal';

export default DeleteQuestionModal;